import { AnimatePresence, motion } from "motion/react";
import { Icon } from "../icons/icons";
import { useColorModeContext } from "./color-mode-provider";

export function ColorModeIcon() {
	/** Context */
	const { colorMode } = useColorModeContext();

	/** Render */
	return (
		<AnimatePresence mode="popLayout">
			<motion.div
				key={colorMode}
				initial={{ opacity: 0, scale: 0 }}
				animate={{ opacity: 1, scale: 1 }}
				exit={{ opacity: 0, scale: 0 }}
				transition={{ duration: 0.35, ease: "circInOut" }}
			>
				{colorMode === "dark" ? (
					<Icon
						name="Moon"
						className="text-blue-500"
					/>
				) : (
					<Icon
						name="Sun"
						className="text-amber-500"
					/>
				)}
			</motion.div>
		</AnimatePresence>
	);
}
